import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowUpRight } from 'lucide-react';
import { articles } from '../../data/mock';

const ArticlesSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('active');
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.reveal, .reveal-scale');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16 reveal">
          <div>
            <span className="inline-block px-4 py-1.5 bg-[#ff6b35]/10 text-[#ff6b35] text-sm font-semibold rounded-full mb-4">
              Blog & Insights
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Latest Articles
            </h2>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-[#ff6b35] font-semibold hover:gap-3 transition-all"
          >
            View All Articles
            <ArrowUpRight className="w-5 h-5" />
          </Link>
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <article
              key={article.id}
              className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 reveal-scale"
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-2 text-gray-400 text-sm mb-3">
                  <Calendar className="w-4 h-4" />
                  <span>{article.date}</span>
                  <span>•</span>
                  <span>{article.author}</span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#ff6b35] transition-colors">
                  {article.title}
                </h3>

                <Link
                  to={article.href}
                  className="inline-flex items-center gap-2 text-[#ff6b35] font-semibold text-sm"
                >
                  Read Article
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticlesSection;
